import React from 'react';
import { Info, Visibility, VisibilityOff } from '@mui/icons-material';
import { Tooltip, Switch, FormControlLabel } from '@mui/material';
import { formatHorizonDisplay, ExposureHorizonWindow } from '../utils/exposureHorizon';

interface ExposureHorizonTableBannerProps {
  window: ExposureHorizonWindow;
  inScopeCount: number;
  outOfScopeCount: number;
  totalCount: number;
  showOutOfScope: boolean;
  onToggleOutOfScope: (show: boolean) => void;
  categoryName: string; // "Demand", "Supply", "Hedges"
}

export const ExposureHorizonTableBanner: React.FC<ExposureHorizonTableBannerProps> = ({
  window,
  inScopeCount,
  outOfScopeCount,
  totalCount,
  showOutOfScope,
  onToggleOutOfScope,
  categoryName,
}) => {
  const displayRange = formatHorizonDisplay(window);

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-md px-4 py-3 flex items-center gap-4 text-sm">
      <div className="flex items-center gap-2 flex-1">
        <Info className="text-blue-600" fontSize="small" />
        <div>
          <span className="font-medium text-blue-900">Viewing Horizon:</span>
          <span className="text-blue-800 ml-2">{displayRange}</span>
          <span className="text-blue-700 ml-2">({window.horizonMonths} months)</span>
        </div>
      </div>

      <div className="flex items-center gap-3 text-blue-800">
        <Tooltip 
          title={
            <div className="text-xs">
              <div>• In scope: {inScopeCount} positions</div>
              <div>• Out of scope: {outOfScopeCount} positions</div>
              <div>• Total: {totalCount} positions</div>
            </div>
          }
        >
          <span className="cursor-help">
            Showing <span className="font-semibold">{showOutOfScope ? totalCount : inScopeCount}</span> of {totalCount} {categoryName.toLowerCase()} positions
          </span>
        </Tooltip>

        <FormControlLabel
          control={
            <Switch
              checked={showOutOfScope}
              onChange={(e) => onToggleOutOfScope(e.target.checked)}
              size="small"
              color="primary"
            />
          }
          label={
            <span className="text-xs flex items-center gap-1">
              {showOutOfScope ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
              Show out-of-scope
            </span>
          }
          className="m-0"
        />
      </div>
    </div>
  );
};
